import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

/**
 * 查询挂单信息
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryStoreOrderUp(params) {
  params.shopId = getShopId()
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrderUp/queryStoreOrderUp',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除挂单信息
 * @param {Object} data 删除参数
 * @returns {Promise} Promise对象
 */
export function deleteStoreOrderUp(data) {
  data.shopId = getShopId()
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrderUp/deleteStoreOrderUp',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}